import React, { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { createAnnonce } from "../../actions/annonce.action";
import { FaHouse } from "react-icons/fa6";
import { toast, ToastContainer } from "react-toastify";
import PaiementModal from "./AnnoncesInformations";
import { CATEGORIES } from "../categorie.constant";

const LogementForm = ({ utilisateurId }) => {
  const LOGEMENT_CATEGORIE_ID = CATEGORIES.find(cat => cat.label === "Logement")?.id;
  const dispatch = useDispatch();

  const fileInputRef = useRef(null);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    setModalIsOpen(true); 
  }, []);

  const [formData, setFormData] = useState({
    titre: "",
    description: "",
    prix: "",
    surface: "",
    nombrePieces: "",
    ville: "",
    typeBien: "",
    transaction: "",
    exterieur: "",
    frequenceLoyer: "",
    conditionVisite: "",
    images: [],
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = { ...prev, [name]: value };

      if (name === "transaction" && value !== "Location") {
        updated.frequenceLoyer = "";
      }

      return updated;
    });
  };
  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, images: e.target.files }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    const dataToSend = new FormData();
    dataToSend.append("categorieId", LOGEMENT_CATEGORIE_ID);
    dataToSend.append("utilisateur", utilisateurId);
    Object.keys(formData).forEach((key) => {
      if (key === "images") {
        for (let i = 0; i < formData.images.length; i++) {
          dataToSend.append("images", formData.images[i]);
        }
      } else {
        if (key === "frequenceLoyer" && formData.transaction !== "Location") return;
        
        dataToSend.append(key, formData[key]);
      }
    });

    try {
      const response = await dispatch(createAnnonce(dataToSend));

      if (
        response &&
        typeof response === "object" &&
        Object.keys(response.errors || {}).length > 0
      ) {
        console.log("Erreurs reçues :", response.errors);
        setErrors(response.errors);
      } else {
        setFormData({
          titre: "",
          description: "",
          prix: "",
          surface: "",
          nombrePieces: "",
          ville: "",
          typeBien: "",
          transaction: "",
          exterieur: "",
          frequenceLoyer: "",
          conditionVisite: "",
          images: [],
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }

        setErrors({});
        toast.success(
          "Félicitations, votre annonce a bien été créée ! Elle sera soumise à la validation de l'administrateur."
        );
      }
    } catch (err) {
      console.error("Erreur lors de la soumission du formulaire :", err);
    }
  };

  return (
    <>
      <form className="AnnonceForm" onSubmit={handleSubmit}>
        <FaHouse />
        <h2>Créer une annonce pour un logement :</h2>

        {errors.titre && (
          <span className="error">Votre annonce doit avoir un titre</span>
        )}
        <input
          type="text"
          name="titre"
          placeholder="Titre"
          onChange={handleChange}
          value={formData.titre}
        />
        {errors.description && (
          <span className="error">
            Veuillez donner une description pour votre annonce
          </span>
        )}
        <textarea
          name="description"
          placeholder="Description"
          onChange={handleChange}
          value={formData.description}
        />

        {errors.transaction && (
          <span className="error">
            Veuillez renseigner le type de transaction
          </span>
        )}
        <select
          name="transaction"
          onChange={handleChange}
          value={formData.transaction}
        >
          <option value="">Type de transaction</option>
          <option value="Location">Location</option>
          <option value="Achat">Achat</option>
        </select>

        <div className="priceDiv">
          <input
            type="number"
            name="prix"
            placeholder="Prix"
            onChange={handleChange}
            value={formData.prix}
          />
          {formData.transaction === "Location" && (
            <select
              className="frequenceSelect"
              name="frequenceLoyer"
              onChange={handleChange}
            >
              <option value="">Périodicité</option>
              <option value="Jour">Jour</option>
              <option value="Semaine">Semaine</option>
              <option value="Mois">Mois</option>
            </select>
          )}
          <label>FCFA</label>
        </div>

        <input
          type="number"
          name="surface"
          placeholder="Surface"
          onChange={handleChange}
          value={formData.surface}
        />
        <input
          type="number"
          name="nombrePieces"
          placeholder="Nombre de pièces"
          onChange={handleChange}
          value={formData.nombrePieces}
        />
        <input
          type="text"
          name="ville"
          placeholder="Ville du bien"
          onChange={handleChange}
          value={formData.ville}
        />

        {errors.typeBien && (
          <span className="error">Veuillez renseigner le type de bien</span>
        )}
        <select
          name="typeBien"
          onChange={handleChange}
          value={formData.typeBien}
        >
          <option value="">Type de bien</option>
          <option value="Appartement">Appartement</option>
          <option value="Maison">Maison</option>
          <option value="Parking">Parking</option>
          <option value="Immeuble">Immeuble</option>
          <option value="Autres">Autres</option>
        </select>

        {errors.conditionVisite && (
          <span className="error">Indiquer les conditions de la visite</span>
        )}
        <select
          name="conditionVisite"
          onChange={handleChange}
          value={formData.conditionVisite}
        >
          <option value="">Condition de la visite</option>
          <option value="Gratuite">Gratuite</option>
          <option vaue="Payante">Payante</option>
        </select>

        <select
          name="exterieur"
          onChange={handleChange}
          value={formData.exterieur}
        >
          <option value="">Extèrieur disponible</option>
          <option value="Balcon">Balcon</option>
          <option value="Terrasse">Terrasse</option>
          <option value="Jardin">Jardin</option>
          <option value="Autres">Autres</option>
        </select>

        <input
          type="file"
          name="images"
          multiple
          onChange={handleFileChange}
          ref={fileInputRef}
        />
        {errors.images && <span className="error">{errors.images}</span>}

        <button className="button" type="submit">
          Créer l'annonce
        </button>

        {formData.transaction === "Achat" ? (
          <span>Prix de l'annonce : 5000 Francs CFA</span>
        ) : (
        <span>Prix de l'annonce : 2000 Francs CFA</span>
        )}
        <span>Paiement par Orange Money au 07-04-64-27-18</span>
      </form>
      <PaiementModal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
      />
      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
};

export default LogementForm;
